const cleaningJobsForManagerDict = {
    toAssignTabLabel: { en: 'To assign', fr: 'À assigner' },
    toConfirmTabLabel: { en: 'To confirm', fr: 'À confirmer' },
    toDoTabLabel: { en: 'To Do', fr: 'À faire' },
    inProgressTabLabel: { en: 'In progress', fr: 'En cours' },
    doneTabLabel: { en: 'Done', fr: 'Terminé' }
}

export default cleaningJobsForManagerDict;